export const getNameFromAWSLink = (link: string) => {
  const array = link.split(".com/");
  console.log(array)
  return array[1];
};
